// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JfjY","type":"styles_type__3li9F","choices":"styles_choices__1xV33"};